import {
  SETUP_SERVICE_PRICE_DISPLAY,
  SETUP_SERVICE_PRICE_NUMERIC,
  SETUP_SERVICE_PRICE_PERIOD,
} from "@/lib/setup-service-copy";

// No hardcoded price-ID fallbacks (review ACQ-9): the old placeholder IDs
// belonged to a different Stripe account, so a build with missing envs
// produced CTAs that 400 server-side with a generic error. An empty ID
// fails the server allowlist just the same, but is greppable and honest.
const STRIPE_PRICE_MONTHLY =
  process.env.NEXT_PUBLIC_STRIPE_PRICE_MONTHLY ?? "";
const STRIPE_PRICE_ANNUAL =
  process.env.NEXT_PUBLIC_STRIPE_PRICE_ANNUAL ?? "";
const STRIPE_PRICE_BUSINESS_MONTHLY =
  process.env.NEXT_PUBLIC_STRIPE_PRICE_BUSINESS_MONTHLY ??
  process.env.STRIPE_PRICE_BUSINESS_MONTHLY ??
  "";
const STRIPE_PRICE_SITE_CONTROL_MONTHLY =
  process.env.NEXT_PUBLIC_STRIPE_PRICE_SITE_CONTROL_MONTHLY ??
  process.env.STRIPE_PRICE_SITE_CONTROL_MONTHLY ??
  "";

export const PRICING = {
  monthly: {
    price: 39,
    display: "\u00a339",
    displayWithPeriod: "\u00a339/mo",
    stripe: {
      priceId: STRIPE_PRICE_MONTHLY,
    },
  },
  annual: {
    price: 360,
    pricePerMonth: 30,
    display: "\u00a330",
    displayWithPeriod: "\u00a330/mo",
    displayYearly: "\u00a3360/yr",
    stripe: {
      priceId: STRIPE_PRICE_ANNUAL,
    },
  },
  savings: {
    perYear: 108,
    display: "Save \u00a3108/year",
    months: "2 months free",
    percentage: "23%",
  },
  free: {
    price: 0,
    display: "\u00a30",
  },
  business: {
    price: 199,
    display: "\u00a3199",
    displayWithPeriod: "\u00a3199/mo",
    stripe: {
      priceId: STRIPE_PRICE_BUSINESS_MONTHLY,
    },
  },
  // Site Control \u2014 per-site enterprise tier, publicly LAUNCHED (GA). The
  // `site_control` flag is a kill-switch (isSiteControlLive), not a launch gate.
  // STRIPE_PRICE_SITE_CONTROL_MONTHLY drives provisioning after a sales-led sale;
  // it does not gate the marketing surface.
  siteControl: {
    price: 675,
    display: "\u00a3675",
    displayWithPeriod: "\u00a3675/site/mo",
    setupPrice: 5000,
    setupDisplay: "\u00a35,000",
    stripe: {
      priceId: STRIPE_PRICE_SITE_CONTROL_MONTHLY,
    },
  },
  setupService: {
    price: SETUP_SERVICE_PRICE_NUMERIC,
    display: SETUP_SERVICE_PRICE_DISPLAY,
    displayWithPeriod: `${SETUP_SERVICE_PRICE_DISPLAY} ${SETUP_SERVICE_PRICE_PERIOD}`,
  },
} as const;
